/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useRef, useState } from "react";

/** Services */
import ToastService from "../../../../../../../services/toastService/ToastService";
import { removeFormFields, setFieldSetting } from "../../../../../../../utils/formFieldUtils/ManageFields";

/** Common Components */
import FormCreator from "../../../../../../../components/finalForms/FormCreator";
import Buttons from "../../../../../../../components/ui/button/Buttons";
import { FieldSettingType } from "../../../../../../../components/finalForms/libs/data/fieldSettingType";

/** Configuration files */
import { editDepartmentConfig } from "./ContractDepartments.formfield.config";

/**Context */
import { ContractContext } from "../../../../../../../utils/context/ContractContext";

/** RTK Query */
import { useContractDepartmentUpdateCostFromScopesMutation, useEditContractDepartmentsMutation } from "../../../../../../../app/services/contractAPI";
import PropTypes from "prop-types";

const EditDepartment = ({ onClose, rowData, contractId }) => {

  const { contractData } = useContext(ContractContext);

  const filteredForm = removeFormFields(editDepartmentConfig, ['psPONumber'])
  const [editDepartmentForm, setEditDepartmentForm] = useState(filteredForm);
  const [poperDepartment, setPoperDepartment] = useState();

  const EditDepartmentRef = useRef();

  const [editContractDepartments, {
    isSuccess: iseditContractDepartments,
    data: editContractDepartmentsData,
  },] = useEditContractDepartmentsMutation();

  const [contractDepartmentUpdateCostFromScopes] = useContractDepartmentUpdateCostFromScopesMutation();

  useEffect(() => {
    if (contractData) {
      setPoperDepartment(contractData?.bCostsPerDepartment)
    }
  }, [contractData])


  useEffect(() => {
    if (rowData) {
      const updatedForm = { ...editDepartmentForm };
      updatedForm.initialState = {
        sClientName1: rowData?.client,
        sdepartment: rowData?.department,
        pbCalcCostFromScopes: rowData?.bCalcCostFromScopes,
        pnCost: rowData?.nCost?.replace('$', ''),
        pdtEffectiveDate: new Date(rowData?.effectiveDate),
        pdtEndDate: new Date(rowData?.endDate),
        pbNonBillable: rowData?.sNonBillable === 'X' ? true : false,
        psPONumber: rowData?.sPONumber,
      };
      setFieldSetting(updatedForm, "pnCost", FieldSettingType.DISABLED, updatedForm.initialState.pbCalcCostFromScopes);
      if (poperDepartment === true) {
        setEditDepartmentForm({
          ...editDepartmentConfig,
          initialState: updatedForm.initialState || {}
        });
      }
      else {
        setEditDepartmentForm(updatedForm);
      }
    }
  }, [rowData, poperDepartment]);

  const handalColumnChange = (dataField, updatedData) => {
    if (dataField === "pbCalcCostFromScopes") {
      let updatedForm = { ...editDepartmentForm };
      setFieldSetting(updatedForm, "pnCost", FieldSettingType.DISABLED, updatedData?.pbCalcCostFromScopes);
    }
  }

  const handleSaveClick = () => {
    const formData = EditDepartmentRef.current.getFormData();
    if (formData) {
      const req = {
        plContractDepartmentKey: rowData?.lContractDepartmentKey,
        pdtEffectiveDate: formData?.pdtEffectiveDate,
        pdtEndDate: formData?.pdtEndDate,
        pnCost: formData.pnCost ? parseFloat(formData.pnCost) : 0,
        pbNonBillable: formData?.pbNonBillable,
        pbCalcCostFromScopes: formData?.pbCalcCostFromScopes || false,
        psPONumber: formData?.psPONumber
      };
      editContractDepartments(req);
    }
  };

  const resetForm = () => {
    const updatedForm = { ...editDepartmentForm };
    updatedForm.initialState = {};
    setEditDepartmentForm(updatedForm);
  };


  useEffect(() => {
    const processUpdate = async () => {
      if (iseditContractDepartments && editContractDepartmentsData) {
        if (editContractDepartmentsData?.errorMessage) {
          try {
            await contractDepartmentUpdateCostFromScopes({
              plContractKey: Number(contractId),
              plDepartmentKey: rowData?.lDepartmentKey
            }).unwrap();
            ToastService.success(editContractDepartmentsData?.errorMessage);
            onClose();
            resetForm();
          } catch (error) {
            console.error("Update cost failed:", error);
          }
        }
      }
    };
    processUpdate();
  }, [iseditContractDepartments, editContractDepartmentsData]);

  return (
    <div className="">
      <FormCreator ref={EditDepartmentRef} config={editDepartmentForm} onColumnChange={handalColumnChange} />
      <div className="d-flex justify-content-end gap-3 mt-2">
        <Buttons
          buttonText="Save"
          onClick={handleSaveClick}
          buttonTypeClassName="btn blue-btn"
          titleText="Save Department"
        />
        <Buttons
          buttonText="Cancel"
          onClick={onClose}
          buttonTypeClassName="btn dark-btn"
          titleText="Cancel"
        />
      </div>
    </div>
  );
};
EditDepartment.propTypes = {
  onClose: PropTypes.func,
  contractId: PropTypes.number,
  rowData: PropTypes.shape({
    lContractDepartmentKey: PropTypes.number,
    client: PropTypes.string,
    department: PropTypes.string,
    bCalcCostFromScopes: PropTypes.bool,
    nCost: PropTypes.string,
    effectiveDate: PropTypes.string,
    endDate: PropTypes.string,
    sNonBillable: PropTypes.string,
    sPONumber: PropTypes.string,
    lDepartmentKey: PropTypes.number,
  }),
};
export default EditDepartment;
